import { Loader } from 'component/Loader/Loader'
import { Space } from 'component/Space'
import { Gap } from 'component/Space/Gap'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { Banners } from 'page/GeneratingScreen/Banners'
import { Page } from 'page/Page/Page'
import { controller } from 'store/controller'
import { opt, STAND_BANNER } from 'store/opt'
import { store } from 'store/store'
import { ErrorType, getErrorDescription, getErrorTitle } from 'type/ErrorType'

function renderError() {
  const error: ErrorType = 'generation-failed'

  return (
    <Vertical center>
      <Icon name="error" size={48} error />
      <Gap height={16} />
      <Typo size={20} upper semi center>
        {getErrorTitle(error)}
      </Typo>
      <Gap height={8} />
      <Typo size={20} center pre error>
        {getErrorDescription(error)}
      </Typo>
    </Vertical>
  )
}

function renderProcessing() {
  const video = store.generating?.video
  return (
    <Vertical tall>
      <Vertical tall center flex="1">
        <Space center>
          <Loader />
        </Space>
        <Gap height={40} />
        <Typo size={32} upper semi center>
          {video ? i18n('CreatingVideo') : i18n('CreatingOutfit')}
        </Typo>
        <Gap height={8} />
        <Typo size={24} pre secondary center>
          {i18n('CreatingOutfitShort')}
        </Typo>
      </Vertical>
      {opt.stand && STAND_BANNER && <Banners />}
    </Vertical>
  )
}

export const BasicGeneratingScreen = observer(() => {
  const error = store.generating?.error && !store.basicPending
  const view = error ? renderError() : renderProcessing()

  const onBack = useLatestCallback(async () => {
    controller.openStart()
  })

  return (
    <Page full clear center onBack={onBack}>
      {view}
    </Page>
  )
})
